import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkRecruitmentDetail({recruitment = {}, children}) {
    const nameSlug = changeToSlug(recruitment.recruitment_name || recruitment.title);
    const id = recruitment.recruitment_id || recruitment.id;
    const slug = nameSlug && id ? `${nameSlug}-r${id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
